<app-navigation>
</app-navigation>


<!--div class="footer" style="float: right;">
	<app-footer></app-footer>
</div-->

<app-ping></app-ping>
<app-idle-timeout></app-idle-timeout>
<app-session-tracker></app-session-tracker>